<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 32 32">
    <g fill="none" fill-rule="evenodd">
      <path d="M-201-249h1846V58H-201z"></path>
      <path d="M0 0h32v32H0z"></path>
      <path
        stroke="#FFF"
        stroke-width="2"
        :fill="isFilled ? '#fff' : 'none'"
        d="M21.302 24.865l-1.404-6.353 4.75-4.332-6.256-.565L16 7.676l-2.392 5.939-6.256.565 4.75 4.332-1.405 6.354L16 21.5l5.302 3.365z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StarIcon',

  props: {
    isFilled: {
      type: Boolean,
      default: false
    }
  }
}
</script>